export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10863.65275e9e.jpg";